<template>
  <div class="tabbox flex-row">
    <div :class="ontype == 0 ? 'ontabitem tabitem' : 'tabitem'" @click="$router.push({ name: 'Home' })">
      招聘职位
    </div>
    <div :class="ontype == 1 ? 'ontabitem tabitem' : 'tabitem'" @click="$router.push({ name: 'About' })">
      单位介绍
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ontype: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="less" scoped>
.tabbox {
  border-radius: 16px 16px 0px 0px;
  border: 1px solid #3466cc;
  width: 336px;
  font-size: 18px;
  color: #3466cc;
  height: 48px;
  overflow: hidden;

  .tabitem {
    text-align: center;
    line-height: 48px;
    width: 50%;
    height: 100%;
    cursor:pointer;
  }

  .ontabitem {
    background: #3466cc;
    color: #fff;
  }
}
</style>
